/**
 * Mirrors the old-react FixedButtons form POST to `/order` with `_eventId=buyNow`.
 * Fields match the legacy Spring backend contract exactly.
 */

/** Calculates the recommended GMS installment amount from a product price. */
function calcGmsRecommendedAmount(price: number): number {
  const installment = Math.ceil(price / 1100) * 100;
  return installment > 1000 ? installment : 1000;
}

export interface BuyNowFormParams {
  customizationId: number;
  /** Size key (e.g. "7") for ring/bracelet — pass empty string if product is not sizeable. */
  sizeSelected: string;
  discountedPrice: number | null;
}

/**
 * Programmatically creates and submits a hidden form to the legacy `/order` endpoint.
 * This matches the old-react `FixedButtons.handleBuyNow` form POST approach.
 */
export function submitBuyNowForm({ customizationId, sizeSelected, discountedPrice }: BuyNowFormParams): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${window.location.origin}/order`;

  const fields: Record<string, string> = {
    _eventId: 'buyNow',
    pageType: 'product',
    referer_pd: 'Product Page',
    customizationId: String(customizationId),
    sizeSelected,
    cartType: 'jewellery',
    recommendedGMSAmount: discountedPrice != null ? String(calcGmsRecommendedAmount(discountedPrice)) : '',
  };

  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
